import React from 'react';
import { Nav, Tab } from 'react-bootstrap';

const CierreTabs = ({ tabs, defaultActiveKey = null }) => {
  const defaultKey = defaultActiveKey || (tabs && tabs.length > 0 ? tabs[0].eventKey : '');

  return (
    <Tab.Container id="cierre-tabs" defaultActiveKey={defaultKey}>
      <Nav variant="pills" className="justify-content-center border-bottom border-1 spread-font mb-4">
        {tabs?.map((tab, index) => (
          <Nav.Item key={index} bsPrefix="subheader-item">
            <Nav.Link
              as="button"
              bsPrefix="subheader-link"
              eventKey={tab.eventKey}
            >
              <p className="mb-0">{tab.title}</p>
            </Nav.Link>
          </Nav.Item>
        ))}
      </Nav>
      
      <Tab.Content className="gx-0 px-0 mx-0">
        {tabs?.map((tab, index) => (
          <Tab.Pane key={index} eventKey={tab.eventKey} mountOnEnter unmountOnExit>
            <div style={{ margin: "0px" }}>
              {tab.component}
            </div>
          </Tab.Pane>
        ))}
      </Tab.Content>
    </Tab.Container>
  );
};

export default CierreTabs;
